<template>
  <div class="text-center">
    <div class="p-5" v-if="uploading">
      <h1 class="text-primary">UPLOAD : {{ progress }}% </h1>

      <h6>Upload {{ formatBytes(uploadedSize) }} / {{ formatBytes(totalSize) }}</h6>
      Chunk ({{ chunkLength - chunks.length }} from {{ chunkLength }}) Upload {{ Number(String(this.uploaded).substring(0,
        2)) }}%
      <vs-progress :percent="Number(String(this.uploaded).substring(0, 2))" color="success">primary</vs-progress>
      <vs-progress :percent="progress" color="primary">primary</vs-progress>

    </div>


    <div class="mt-4 card bordered">

      <input type="file" name="videoFile" id="" ref="file" @change="handleUploadFile" />
      <vs-button @click="upload">upload </vs-button>
    </div>

    <template lang="html">
      <div>
        <br /><br />
        <vs-table :data="queueVideos" style="direction: ltr">
          <template slot="header">
            <h3 class="flex">
              <vs-button radius color="warning" type="filled" icon="refresh" size="small" @click="fetchQueueVideos">
              </vs-button>
              Queue Videos
            </h3>
          </template>
          <template slot="thead">
            <vs-th> Container </vs-th>
            <vs-th> Status </vs-th>
            <vs-th> size </vs-th>
            <vs-th> storage </vs-th>

            <vs-th> Progress </vs-th>
            <vs-th> Actions </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].container">
                {{ data[indextr].resolution }}p
              </vs-td>

              <vs-td :data="data[indextr].resolution">
                {{ data[indextr].resolution }}
              </vs-td>

              <vs-td :data="data[indextr].size">
                {{ data[indextr].size }}
              </vs-td>

              <vs-td :data="data[indextr].storage">
                {{ data[indextr].storage }}
              </vs-td>

              <vs-td :data="data[indextr].progress">
                <div v-if="data[indextr].done == 1 && data[indextr].progress == 0">complete</div>
                <div v-if="data[indextr].done == 0 && data[indextr].progress == 1">
                  <vs-chip size="sm" class="badge" v-for="(item, i) in data[indextr].ps"><b>{{ i }}</b> : {{ item
                  }}</vs-chip>

                </div>

              </vs-td>

              <vs-td :data="data[indextr].id">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                  @click="delQueueVideo(tr)" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <hr />
        <br />
        <vs-table :data="videos" style="direction: ltr">
          <template slot="header">
            <h3>Videos</h3>
          </template>
          <template slot="thead">
            <vs-th> Container </vs-th>
            <vs-th> Resolution </vs-th>
            <vs-th> Extension </vs-th>
            <vs-th> Actions </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].container">
                {{ data[indextr].container }}
              </vs-td>

              <vs-td :data="data[indextr].resolution">
                {{ data[indextr].resolution }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].id">
                <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                  @click="download(data[indextr])" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                  @click="delVideos(data[indextr].id)" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </template>
  </div>
</template>
</template>
<script>
export default {
  props: ["movie"],
  data() {
    return {
      file: "",
      // progress: 0,
      loading: false,
      uploading: false,
      convert: false,
      videos: [],
      chunks: [],
      uploaded: 0,
      chunk: 1,
      chunkLength: 0,
      chunkTotal: 0,
      queueVideos: [],
      uploadedSize: 0,
      totalSize: 0
    };
  },
  created() {
    var vm = this;
    this.fetchVideos();
    this.fetchQueueVideos();
    setInterval(() => {
      vm.fetchVideos();
      vm.fetchQueueVideos();
    }, 50000);
  },
  computed: {
    progress() {
      if (this.chunks.length != 0) {
        return Math.floor((this.chunk / this.chunkLength) * 100);
      } else {
        return 0;
      }

    },
    formData() {
      let formData = new FormData;

      formData.set('is_last', this.chunks.length === 1);
      formData.set('file', this.chunks[0], `${this.file.name}.part`);
      formData.set("movie_id", this.movie.response.id);
      formData.set("part", this.chunk);
      return formData;
    },
    config() {
      return {
        headers: {
          'Content-Type': 'application/octet-stream'
        },
        onUploadProgress: event => {
          this.uploaded += event.loaded;
        }
      };
    }
  },
  // watch: {
  //   chunks(n, o) {
  //     if (n.length > 0) {
  //       this.upload();
  //     }
  //   }
  // },
  methods: {
    download(item) {

      window.open(
        item.filename,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    handleUploadFile(event) {
      this.file = event.target.files.item(0);
      this.totalSize = this.file.size
      this.createChunks();
      this.chunkLength = this.chunks.length;
    },
    upload() {

      this.uploading = true;
      const data = new FormData();
      // data.append("file", this.file);
      // data.append("movie_id", this.movie.response.id);
      data.set('is_last', this.chunks.length === 1);
      data.set('file', this.chunks[0], `${this.file.name}.part`);
      data.set("movie_id", this.movie.response.id);
      data.set("chunk", this.hunkLength - this.chunks.length);
      var vm = this;
      // let config = {
      //   onUploadProgress(progressEvent) {
      //     var percentCompleted = Math.round(
      //       (progressEvent.loaded * 100) / progressEvent.total
      //     );

      //     // execute the callback
      //     //if (onProgress) onProgress(percentCompleted)
      //     vm.progress = percentCompleted;
      //     return percentCompleted;
      //   },
      // };
      this.loading = true;
      this.uploaded = 0;
      this.axios.post(`http://172.18.0.137/api/upload`, data, this.config).then(res => {
        if (res.status == 200) {
          this.chunk++;
          this.uploadedSize += this.chunks[0].size;
          this.chunks.shift();

          this.uploading = false;
          this.$emit("success", res.data);
          this.loading == false
          // this.fetchVideos();
          // this.fetchQueueVideos();
          // this.uploading = false;
          // this.$emit('success', res.data);
          //  this.fetchVideos(); 
          if (this.chunks.length != 0) {

            this.upload();
          } else {
            this.chunk = 0;
            this.uploadedSize = 0;
            this.uploading = false;
            this.chunkLength = 0;
            this.totalSize = 0;
            this.file = "";
            this.loading == false
          }

        }

      }).catch(error => {
        this.upload();
      })


      // this.axios
      //   .post(this.config)
      //   .then((res) => {
      //     this.chunks.shift();
      //     this.uploading = false;
      //     this.$emit("success", res.data);
      //     this.fetchVideos();
      //     this.fetchQueueVideos();
      //   });
    },
    async createChunks() {

      let size = this.file.size > 2000000 ? 8388608 * 4 : this.file.size;
      let chunks = Math.ceil(this.file.size / size);
      for (let i = 0; i < chunks; i++) {
        var chunk = this.file.slice(i * size, Math.min(i * size + size, this.file.size), this.file.type)
        this.chunks.push(chunk);
      }
    },
    fetchVideos() {
      this.axios
        .get(`${this.$apiUrl}/v2/movies/videos/${this.movie.response.id}`)
        .then((res) => {
          this.videos = res.data;
        });
    },
    fetchQueueVideos() {
      this.axios
        .get(`http://172.18.0.137/api/videos/all/${this.movie.response.id}`)
        .then((res) => {
          this.queueVideos = res.data;
        });
    },
    delQueueVideo(id) {
      if (confirm("are you sure")) {
        this.axios.post(`http://172.18.0.137/api/delete/${id}`).then((res) => {
          this.fetchQueueVideos();
        });
      }
    },
    delVideos(video) {
      if (confirm("are you sure")) {
        this.axios
          .post(`${this.$apiUrl}/v2/movies/destroyVideos/${video}`)
          .then((res) => {
            this.fetchVideos();
          });
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
  },
};
</script>
<style lang="scss">
.vs-table--tbody-table tr {
  text-align: left;
}
</style>